import {
  AiRequestMetadataInput as ChAiRequestMetadataInput,
  TranslateInput,
} from "@/modules/chats/services/ai/ch/__generated__/chTranslateQuery.graphql"
import { chTranslateQuery } from "@/modules/chats/services/ai/ch/chTranslateQuery"
import { AiRequestMetadataInput as DeAiRequestMetadataInput } from "@/modules/chats/services/ai/de/__generated__/deTranslateQuery.graphql"
import { deTranslateQuery } from "@/modules/chats/services/ai/de/deTranslateQuery"
import { Country } from "@/types/__generated__/union-types"

export type AiRequestMetadataInput = ChAiRequestMetadataInput | DeAiRequestMetadataInput

export const translateQuery = (country: Country, input: TranslateInput) => {
  if (country === "DE") {
    return deTranslateQuery(input)
  }
  return chTranslateQuery(input)
}
